module.exports = __webpack_public_path__ + "img/should_exclude.44997279.svg";